import { type ApprovalRejectionReason, ApprovalSubmitRequestSchema } from "@adpilot/shared";

type DraftDecision = "approve" | "reject" | "modify_approve";

export interface ActionDecisionDraft {
  decision: DraftDecision;
  modifiedBid: string;
  reasonCode: ApprovalRejectionReason | null;
}

/** One reviewed Action becomes one immediate partial submission. */
export function buildActionDecisionSubmission(
  actionId: string,
  draft: ActionDecisionDraft,
): ReturnType<typeof ApprovalSubmitRequestSchema.safeParse> {
  if (draft.decision === "reject") {
    return ApprovalSubmitRequestSchema.safeParse({
      actions: [
        {
          actionId,
          decision: "reject",
          ...(draft.reasonCode ? { reasonCode: draft.reasonCode } : {}),
        },
      ],
    });
  }
  if (draft.decision === "modify_approve") {
    return ApprovalSubmitRequestSchema.safeParse({
      actions: [{ actionId, decision: "modify_approve", modifiedBid: Number(draft.modifiedBid) }],
    });
  }
  return ApprovalSubmitRequestSchema.safeParse({
    actions: [{ actionId, decision: "approve" }],
  });
}
